import React, { useEffect, useState } from 'react';
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export default function Index() {
  const [postData, setPostData] = useState(null);
  const contentList = useSelector(state => state.home.contentList);

  useEffect(() => {
    const singleContent = contentList.find(ele => ele.menu === 'home');
    setPostData(singleContent);
  }, [contentList]);

  function removeExtraSpaces(htmlContent) {
    return htmlContent.replace(/&nbsp;+/g, ' ');
  }

  return (
    <div className='websiteApp'>
      <Header />
      {postData && (
        <>
          <section
            className="banner-section"
            style={{ background: `url(/uploads/${postData.image}) no-repeat` }}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="banner-content-wrapper">
                    <figure>
                      <img src="images/GII-Logo44.png" alt="Logo" />
                    </figure>
                    <div dangerouslySetInnerHTML={{ __html: removeExtraSpaces(postData.content_section) }} />
                    <div className="register-form">
                      <Link className="register-today" to="/register" aria-invalid="true">
                        Register Today
                      </Link>
                    </div>
                    <div className="watch-video-wrapper">
                      <Link
                        className="watch-video-link"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        to="#"
                        aria-invalid="true"
                      >
                        Watch the introduction
                      </Link>
                      <div
                        className="modal fade"
                        id="exampleModal"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                        tabIndex="-1"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-body">
                              <button
                                type="button"
                                className="close-button"
                                data-bs-dismiss="modal"
                              ></button>
                              <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                                <iframe
                                  style={{
                                    position: 'absolute',
                                    top: '0px',
                                    left: '0px',
                                    width: '100%',
                                    height: '100%',
                                  }}
                                  title="videoiframe"
                                  src="https://player.vimeo.com/video/113706870"
                                  frameBorder="0"
                                  allowFullScreen
                                ></iframe>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div dangerouslySetInnerHTML={{ __html: removeExtraSpaces(postData.content_section2) }} />
        </>
      )}
      <Footer />
    </div>
  );
}
